import { ScrollViewProps } from '@betty/moonlight';

export const UPLOAD_DOCUMENTS_INFO_SECTIONS = ['Id', 'Statement'] as const;

export const CONTENT_CONTAINER_STYLE: Required<ScrollViewProps>['contentContainerStyle'] =
  {
    gap: 'space-400',
    paddingVertical: 'space-400',
    paddingHorizontal: 'space-600',
  };
